import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalServices, selectIsSubscription } from '../../../../../../../../selectors/buyPackageModal';
import { PriceCell } from '../PriceCell';
import { ServiceCell } from '../ServiceCell';
import { EServiceType } from '../../../../../../../../types';
import { AuctionPointsHint } from './components/AuctionPointsHint';
import { TableRow } from '../TableRow';
import { getTypeName } from './utils';

export const ServicesContainer = () => {
  const services = useSelector(selectBuyPackageModalServices);
  const isSubscription = useSelector(selectIsSubscription);

  const typeName = getTypeName(isSubscription);

  return (
    <>
      {services.map((service, key) => (
        <TableRow key={key}>
          <ServiceCell
            name={service.name}
            count={service.count}
            durationInDays={service.durationInDays}
            hint={service.serviceType === EServiceType.Auction && <AuctionPointsHint typeName={typeName} />}
          />

          <PriceCell price={service.price} marketingPrice={service.marketingPrice} />
        </TableRow>
      ))}
    </>
  );
};
